import { Box, Typography } from '@mui/material';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { useGetMyCreditCardsQuery} from '../../../services/creditCards';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../../features/auth/authSlice';
import UserDecryptCreditCardPopover from '../../../components/creditCards/UserDecryptCreditCardPopover';

const CreditCards = () => {
  const user = useSelector(selectCurrentUser);
  const userDistribution = user?.userDistribution;
  const {data: creditCards, isLoading} = useGetMyCreditCardsQuery({isDeleted: false, isActive: true});
  // let creditCards = creditCardsApiRes?.response || [];

  function getExpirationDate(params) {
    return `${params.row.expirMonth || ''}/${params.row.expirYear || ''}`;
  }

  const columns = [
    { field: 'nameOnCard', headerName: 'NAME ON CARD', flex: 1 },
    { field: 'cardType.name', headerName: 'CARD TYPE NAME', flex: 1, valueGetter: (params) => params.row.cardTypeName },
    { field: 'last4Digits', headerName: 'LAST 4 DIGITS', flex: 1 },
    { field: 'expirationDate', headerName: "EXPIRATION DATE", valueGetter: getExpirationDate, flex: 1 },
    {
      field: 'details', headerName: '', width: 50, align: 'center',
      renderCell: (params) => (
        <UserDecryptCreditCardPopover creditCardId={params.row.id} />
      )
    }
  ];

  if (userDistribution === undefined || userDistribution === false) {
    return (
      <Box sx={{width: '100%', display: 'flex', justifyContent: 'center'}}>
        <Typography variant="h5" sx={{ fontWeight: 700, color: 'var(--orange)'}}>
          You do not have permission to view this content.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', height: 500 }}>
      <h3 style={{ color: 'var(--orange)', marginBottom: '1em' }}>Credit Cards</h3>

      <DataGridPremium
        pagination
        paginationMode="server"
        rows={creditCards || []}
        columns={columns}
        loading={isLoading}
      />
    </Box>
  );
};

export default CreditCards;
